var map = {
	"./banner-assets/en/banner0": 2,
	"./banner-assets/en/banner0.jpg": 2,
	"./banner-assets/en/banner1": 3,
	"./banner-assets/en/banner1.jpg": 3,
	"./banner-assets/en/banner2": 4,
	"./banner-assets/en/banner2.jpg": 4,
	"./banner-assets/en/banner3": 5,
	"./banner-assets/en/banner3.jpg": 5,
	"./banner-assets/en/banner4": 6,
	"./banner-assets/en/banner4.jpg": 6,
	"./banner-assets/th/banner0": 7,
	"./banner-assets/th/banner0.jpg": 7,
	"./banner-assets/th/banner1": 8,
	"./banner-assets/th/banner1.jpg": 8,
	"./banner-assets/th/banner2": 9,
	"./banner-assets/th/banner2.jpg": 9,
	"./banner-assets/th/banner3": 10,
	"./banner-assets/th/banner3.jpg": 10,
	"./banner-assets/th/banner4": 11,
	"./banner-assets/th/banner4.jpg": 11,
	"./banner-assets/zh-cn/banner0": 12,
	"./banner-assets/zh-cn/banner0.jpg": 12,
	"./banner-assets/zh-cn/banner1": 13,
	"./banner-assets/zh-cn/banner1.jpg": 13,
	"./banner-assets/zh-cn/banner2": 14,
	"./banner-assets/zh-cn/banner2.jpg": 14,
	"./banner-assets/zh-cn/banner3": 15,
	"./banner-assets/zh-cn/banner3.jpg": 15,
	"./banner-assets/zh-cn/banner4": 16,
	"./banner-assets/zh-cn/banner4.jpg": 16,
	"./banner-assets/zh-tw/banner0": 17,
	"./banner-assets/zh-tw/banner0.jpg": 17,
	"./banner-assets/zh-tw/banner1": 18,
	"./banner-assets/zh-tw/banner1.jpg": 18,
	"./banner-assets/zh-tw/banner2": 19,
	"./banner-assets/zh-tw/banner2.jpg": 19,
	"./banner-assets/zh-tw/banner3": 20,
	"./banner-assets/zh-tw/banner3.jpg": 20,
	"./banner-assets/zh-tw/banner4": 21,
	"./banner-assets/zh-tw/banner4.jpg": 21,
	"./event/bg": 22,
	"./event/bg.png": 22,
	"./event/bg_m": 23,
	"./event/bg_m.png": 23,
	"./event/btn": 24,
	"./event/btn.png": 24,
	"./favicon": 25,
	"./favicon.png": 25,
	"./flag/bd": 26,
	"./flag/bd.jpg": 26,
	"./flag/ch": 27,
	"./flag/ch.jpg": 27,
	"./flag/cs": 28,
	"./flag/cs.jpg": 28,
	"./flag/en": 29,
	"./flag/en.jpg": 29,
	"./flag/gb": 30,
	"./flag/gb.jpg": 30,
	"./flag/id": 31,
	"./flag/id.jpg": 31,
	"./flag/in": 32,
	"./flag/in.jpg": 32,
	"./flag/th": 33,
	"./flag/th.jpg": 33,
	"./flag/vn": 34,
	"./flag/vn.jpg": 34,
	"./footer/ffa": 35,
	"./footer/ffa.png": 35,
	"./footer/gga": 36,
	"./footer/gga.png": 36,
	"./footer/iea": 37,
	"./footer/iea.png": 37,
	"./footer/sfa": 38,
	"./footer/sfa.png": 38,
	"./game_icon/en/AB1001": 39,
	"./game_icon/en/AB1001.png": 39,
	"./game_icon/en/AB1002": 40,
	"./game_icon/en/AB1002.png": 40,
	"./game_icon/en/AB1003": 41,
	"./game_icon/en/AB1003.png": 41,
	"./game_icon/en/AB1004": 42,
	"./game_icon/en/AB1004.png": 42,
	"./game_icon/en/AB1005": 43,
	"./game_icon/en/AB1005.png": 43,
	"./game_icon/en/AB1006": 44,
	"./game_icon/en/AB1006.png": 44,
	"./game_icon/en/AB1007": 45,
	"./game_icon/en/AB1007.png": 45,
	"./game_icon/en/AB1008": 46,
	"./game_icon/en/AB1008.png": 46,
	"./game_icon/en/AB1009": 47,
	"./game_icon/en/AB1009.png": 47,
	"./game_icon/en/AB1010": 48,
	"./game_icon/en/AB1010.png": 48,
	"./game_icon/en/AB1011": 49,
	"./game_icon/en/AB1011.png": 49,
	"./game_icon/en/AB1012": 50,
	"./game_icon/en/AB1012.png": 50,
	"./game_icon/en/AB1013": 51,
	"./game_icon/en/AB1013.png": 51,
	"./game_icon/en/AB1014": 52,
	"./game_icon/en/AB1014.png": 52,
	"./game_icon/en/AB1015": 53,
	"./game_icon/en/AB1015.png": 53,
	"./game_icon/en/AB1016": 54,
	"./game_icon/en/AB1016.png": 54,
	"./game_icon/en/AB1017": 55,
	"./game_icon/en/AB1017.png": 55,
	"./game_icon/en/AB1018": 56,
	"./game_icon/en/AB1018.png": 56,
	"./game_icon/en/AB1019": 57,
	"./game_icon/en/AB1019.png": 57,
	"./game_icon/en/AB1020": 58,
	"./game_icon/en/AB1020.png": 58,
	"./game_icon/en/AB1021": 59,
	"./game_icon/en/AB1021.png": 59,
	"./game_icon/en/AB1022": 60,
	"./game_icon/en/AB1022.png": 60,
	"./game_icon/en/AB1023": 61,
	"./game_icon/en/AB1023.png": 61,
	"./game_icon/en/AB1024": 62,
	"./game_icon/en/AB1024.png": 62,
	"./game_icon/en/AB1025": 63,
	"./game_icon/en/AB1025.png": 63,
	"./game_icon/en/AB1026": 64,
	"./game_icon/en/AB1026.png": 64,
	"./game_icon/en/AB1027": 65,
	"./game_icon/en/AB1027.png": 65,
	"./game_icon/en/AB1028": 66,
	"./game_icon/en/AB1028.png": 66,
	"./game_icon/en/AB1029": 67,
	"./game_icon/en/AB1029.png": 67,
	"./game_icon/en/AB1030": 68,
	"./game_icon/en/AB1030.png": 68,
	"./game_icon/en/AB1031": 69,
	"./game_icon/en/AB1031.png": 69,
	"./game_icon/en/AB1032": 70,
	"./game_icon/en/AB1032.png": 70,
	"./game_icon/en/AB1033": 71,
	"./game_icon/en/AB1033.png": 71,
	"./game_icon/en/AB1034": 72,
	"./game_icon/en/AB1034.png": 72,
	"./game_icon/en/AB1035": 73,
	"./game_icon/en/AB1035.png": 73,
	"./game_icon/en/AB1036": 74,
	"./game_icon/en/AB1036.png": 74,
	"./game_icon/en/AB1037": 75,
	"./game_icon/en/AB1037.png": 75,
	"./game_icon/en/AB1038": 76,
	"./game_icon/en/AB1038.png": 76,
	"./game_icon/en/AB1039": 77,
	"./game_icon/en/AB1039.png": 77,
	"./game_icon/en/AB1040": 78,
	"./game_icon/en/AB1040.png": 78,
	"./game_icon/en/AB1041": 79,
	"./game_icon/en/AB1041.png": 79,
	"./game_icon/en/AB1042": 80,
	"./game_icon/en/AB1042.png": 80,
	"./game_icon/en/AB1043": 81,
	"./game_icon/en/AB1043.png": 81,
	"./game_icon/en/AB1044": 82,
	"./game_icon/en/AB1044.png": 82,
	"./game_icon/en/AB1045": 83,
	"./game_icon/en/AB1045.png": 83,
	"./game_icon/en/AB1046": 84,
	"./game_icon/en/AB1046.png": 84,
	"./game_icon/en/AB1047": 85,
	"./game_icon/en/AB1047.png": 85,
	"./game_icon/en/AB1048": 86,
	"./game_icon/en/AB1048.png": 86,
	"./game_icon/en/AB1049": 87,
	"./game_icon/en/AB1049.png": 87,
	"./game_icon/en/AB1050": 88,
	"./game_icon/en/AB1050.png": 88,
	"./game_icon/en/AB1051": 89,
	"./game_icon/en/AB1051.png": 89,
	"./game_icon/en/AB1052": 90,
	"./game_icon/en/AB1052.png": 90,
	"./game_icon/en/AB1053": 91,
	"./game_icon/en/AB1053.png": 91,
	"./game_icon/en/AB1054": 92,
	"./game_icon/en/AB1054.png": 92,
	"./game_icon/en/AB1055": 93,
	"./game_icon/en/AB1055.png": 93,
	"./game_icon/en/AB1501": 94,
	"./game_icon/en/AB1501.png": 94,
	"./game_icon/en/AB1502": 95,
	"./game_icon/en/AB1502.png": 95,
	"./game_icon/en/AB1503": 96,
	"./game_icon/en/AB1503.png": 96,
	"./game_icon/en/AB1504": 97,
	"./game_icon/en/AB1504.png": 97,
	"./game_icon/en/AB1505": 98,
	"./game_icon/en/AB1505.png": 98,
	"./game_icon/en/AB1506": 99,
	"./game_icon/en/AB1506.png": 99,
	"./game_icon/en/AB1507": 100,
	"./game_icon/en/AB1507.png": 100,
	"./game_icon/en/AB1508": 101,
	"./game_icon/en/AB1508.png": 101,
	"./game_icon/en/AB1509": 102,
	"./game_icon/en/AB1509.png": 102,
	"./game_icon/en/AB1510": 103,
	"./game_icon/en/AB1510.png": 103,
	"./game_icon/en/AB1511": 104,
	"./game_icon/en/AB1511.png": 104,
	"./game_icon/en/AB1512": 105,
	"./game_icon/en/AB1512.png": 105,
	"./game_icon/en/AB1515": 106,
	"./game_icon/en/AB1515.png": 106,
	"./game_icon/en/AB1516": 107,
	"./game_icon/en/AB1516.png": 107,
	"./game_icon/en/AB1517": 108,
	"./game_icon/en/AB1517.png": 108,
	"./game_icon/en/AB1520": 109,
	"./game_icon/en/AB1520.png": 109,
	"./game_icon/en/AB1521": 110,
	"./game_icon/en/AB1521.png": 110,
	"./game_icon/en/AB1522": 111,
	"./game_icon/en/AB1522.png": 111,
	"./game_icon/en/AB1523": 112,
	"./game_icon/en/AB1523.png": 112,
	"./game_icon/en/AB1524": 113,
	"./game_icon/en/AB1524.png": 113,
	"./game_icon/en/AB1525": 114,
	"./game_icon/en/AB1525.png": 114,
	"./game_icon/en/AB1526": 115,
	"./game_icon/en/AB1526.png": 115,
	"./game_icon/en/AB1527": 116,
	"./game_icon/en/AB1527.png": 116,
	"./game_icon/en/AB1528": 117,
	"./game_icon/en/AB1528.png": 117,
	"./game_icon/en/AB1529": 118,
	"./game_icon/en/AB1529.png": 118,
	"./game_icon/en/AB1530": 119,
	"./game_icon/en/AB1530.png": 119,
	"./game_icon/en/AB1531": 120,
	"./game_icon/en/AB1531.png": 120,
	"./game_icon/en/AB1532": 121,
	"./game_icon/en/AB1532.png": 121,
	"./game_icon/en/AB1534": 122,
	"./game_icon/en/AB1534.png": 122,
	"./game_icon/en/AB2001": 123,
	"./game_icon/en/AB2001.png": 123,
	"./game_icon/en/AB2002": 124,
	"./game_icon/en/AB2002.png": 124,
	"./game_icon/en/AB3001": 125,
	"./game_icon/en/AB3001.png": 125,
	"./game_icon/en/AB4001": 126,
	"./game_icon/en/AB4001.png": 126,
	"./game_icon/en/AB4003": 127,
	"./game_icon/en/AB4003.png": 127,
	"./game_icon/en/AB5001": 128,
	"./game_icon/en/AB5001.png": 128,
	"./game_icon/en/BC1039": 129,
	"./game_icon/en/BC1039.png": 129,
	"./game_icon/en/BC3041": 130,
	"./game_icon/en/BC3041.png": 130,
	"./game_icon/en/BC3049": 131,
	"./game_icon/en/BC3049.png": 131,
	"./game_icon/en/BC4056": 132,
	"./game_icon/en/BC4056.png": 132,
	"./game_icon/en/BC4057": 133,
	"./game_icon/en/BC4057.png": 133,
	"./game_icon/en/BC4058": 134,
	"./game_icon/en/BC4058.png": 134,
	"./game_icon/en/BC4062": 135,
	"./game_icon/en/BC4062.png": 135,
	"./game_icon/en/BC4071": 136,
	"./game_icon/en/BC4071.png": 136,
	"./game_icon/en/FT038": 137,
	"./game_icon/en/FT038.png": 137,
	"./game_icon/en/Thumbs.db": 639,
	"./game_icon/en/VG0001": 138,
	"./game_icon/en/VG0001.png": 138,
	"./game_icon/en/VG0002": 139,
	"./game_icon/en/VG0002 2": 140,
	"./game_icon/en/VG0002 2.png": 140,
	"./game_icon/en/VG0002.png": 139,
	"./game_icon/en/VG0003": 141,
	"./game_icon/en/VG0003.png": 141,
	"./game_icon/en/VG0004": 142,
	"./game_icon/en/VG0004.png": 142,
	"./game_icon/en/VG0007": 143,
	"./game_icon/en/VG0007.png": 143,
	"./game_icon/en/VG1001": 144,
	"./game_icon/en/VG1001.png": 144,
	"./game_icon/en/VG1002": 145,
	"./game_icon/en/VG1002.png": 145,
	"./game_icon/en/VG1003": 146,
	"./game_icon/en/VG1003.png": 146,
	"./game_icon/en/VG1004": 147,
	"./game_icon/en/VG1004.png": 147,
	"./game_icon/en/VG1005": 148,
	"./game_icon/en/VG1005.png": 148,
	"./game_icon/en/VG1007": 149,
	"./game_icon/en/VG1007.png": 149,
	"./game_icon/en/VGBACCARAT": 150,
	"./game_icon/en/VGBACCARAT.png": 150,
	"./game_icon/en/VGDRINSECT": 151,
	"./game_icon/en/VGDRINSECT.png": 151,
	"./game_icon/en/VGF01": 152,
	"./game_icon/en/VGF01.png": 152,
	"./game_icon/en/VGF02": 153,
	"./game_icon/en/VGF02.png": 153,
	"./game_icon/en/VGGyumaoC": 154,
	"./game_icon/en/VGGyumaoC.png": 154,
	"./game_icon/en/VGGyumaoM": 155,
	"./game_icon/en/VGGyumaoM.png": 155,
	"./game_icon/en/VGPHOENIX": 156,
	"./game_icon/en/VGPHOENIX.png": 156,
	"./game_icon/en/VGROULETTE": 157,
	"./game_icon/en/VGROULETTE.png": 157,
	"./game_icon/en/VGSEAFOOD2": 158,
	"./game_icon/en/VGSEAFOOD2.png": 158,
	"./game_icon/none": 159,
	"./game_icon/none.png": 159,
	"./game_icon/th/AB1001": 160,
	"./game_icon/th/AB1001.png": 160,
	"./game_icon/th/AB1002": 161,
	"./game_icon/th/AB1002.png": 161,
	"./game_icon/th/AB1003": 162,
	"./game_icon/th/AB1003.png": 162,
	"./game_icon/th/AB1004": 163,
	"./game_icon/th/AB1004.png": 163,
	"./game_icon/th/AB1005": 164,
	"./game_icon/th/AB1005.png": 164,
	"./game_icon/th/AB1006": 165,
	"./game_icon/th/AB1006.png": 165,
	"./game_icon/th/AB1007": 166,
	"./game_icon/th/AB1007.png": 166,
	"./game_icon/th/AB1008": 167,
	"./game_icon/th/AB1008.png": 167,
	"./game_icon/th/AB1009": 168,
	"./game_icon/th/AB1009.png": 168,
	"./game_icon/th/AB1010": 169,
	"./game_icon/th/AB1010.png": 169,
	"./game_icon/th/AB1011": 170,
	"./game_icon/th/AB1011.png": 170,
	"./game_icon/th/AB1012": 171,
	"./game_icon/th/AB1012.png": 171,
	"./game_icon/th/AB1013": 172,
	"./game_icon/th/AB1013.png": 172,
	"./game_icon/th/AB1014": 173,
	"./game_icon/th/AB1014.png": 173,
	"./game_icon/th/AB1015": 174,
	"./game_icon/th/AB1015.png": 174,
	"./game_icon/th/AB1016": 175,
	"./game_icon/th/AB1016.png": 175,
	"./game_icon/th/AB1017": 176,
	"./game_icon/th/AB1017.png": 176,
	"./game_icon/th/AB1018": 177,
	"./game_icon/th/AB1018.png": 177,
	"./game_icon/th/AB1019": 178,
	"./game_icon/th/AB1019.png": 178,
	"./game_icon/th/AB1020": 179,
	"./game_icon/th/AB1020.png": 179,
	"./game_icon/th/AB1021": 180,
	"./game_icon/th/AB1021.png": 180,
	"./game_icon/th/AB1022": 181,
	"./game_icon/th/AB1022.png": 181,
	"./game_icon/th/AB1023": 182,
	"./game_icon/th/AB1023.png": 182,
	"./game_icon/th/AB1024": 183,
	"./game_icon/th/AB1024.png": 183,
	"./game_icon/th/AB1025": 184,
	"./game_icon/th/AB1025.png": 184,
	"./game_icon/th/AB1026": 185,
	"./game_icon/th/AB1026.png": 185,
	"./game_icon/th/AB1027": 186,
	"./game_icon/th/AB1027.png": 186,
	"./game_icon/th/AB1028": 187,
	"./game_icon/th/AB1028.png": 187,
	"./game_icon/th/AB1029": 188,
	"./game_icon/th/AB1029.png": 188,
	"./game_icon/th/AB1030": 189,
	"./game_icon/th/AB1030.png": 189,
	"./game_icon/th/AB1031": 190,
	"./game_icon/th/AB1031.png": 190,
	"./game_icon/th/AB1032": 191,
	"./game_icon/th/AB1032.png": 191,
	"./game_icon/th/AB1033": 192,
	"./game_icon/th/AB1033.png": 192,
	"./game_icon/th/AB1034": 193,
	"./game_icon/th/AB1034.png": 193,
	"./game_icon/th/AB1035": 194,
	"./game_icon/th/AB1035.png": 194,
	"./game_icon/th/AB1036": 195,
	"./game_icon/th/AB1036.png": 195,
	"./game_icon/th/AB1037": 196,
	"./game_icon/th/AB1037.png": 196,
	"./game_icon/th/AB1038": 197,
	"./game_icon/th/AB1038.png": 197,
	"./game_icon/th/AB1039": 198,
	"./game_icon/th/AB1039.png": 198,
	"./game_icon/th/AB1040": 199,
	"./game_icon/th/AB1040.png": 199,
	"./game_icon/th/AB1041": 200,
	"./game_icon/th/AB1041.png": 200,
	"./game_icon/th/AB1042": 201,
	"./game_icon/th/AB1042.png": 201,
	"./game_icon/th/AB1043": 202,
	"./game_icon/th/AB1043.png": 202,
	"./game_icon/th/AB1044": 203,
	"./game_icon/th/AB1044.png": 203,
	"./game_icon/th/AB1045": 204,
	"./game_icon/th/AB1045.png": 204,
	"./game_icon/th/AB1046": 205,
	"./game_icon/th/AB1046.png": 205,
	"./game_icon/th/AB1047": 206,
	"./game_icon/th/AB1047.png": 206,
	"./game_icon/th/AB1048": 207,
	"./game_icon/th/AB1048.png": 207,
	"./game_icon/th/AB1049": 208,
	"./game_icon/th/AB1049.png": 208,
	"./game_icon/th/AB1050": 209,
	"./game_icon/th/AB1050.png": 209,
	"./game_icon/th/AB1051": 210,
	"./game_icon/th/AB1051.png": 210,
	"./game_icon/th/AB1052": 211,
	"./game_icon/th/AB1052.png": 211,
	"./game_icon/th/AB1053": 212,
	"./game_icon/th/AB1053.png": 212,
	"./game_icon/th/AB1054": 213,
	"./game_icon/th/AB1054.png": 213,
	"./game_icon/th/AB1055": 214,
	"./game_icon/th/AB1055.png": 214,
	"./game_icon/th/AB1501": 215,
	"./game_icon/th/AB1501.png": 215,
	"./game_icon/th/AB1502": 216,
	"./game_icon/th/AB1502.png": 216,
	"./game_icon/th/AB1503": 217,
	"./game_icon/th/AB1503.png": 217,
	"./game_icon/th/AB1504": 218,
	"./game_icon/th/AB1504.png": 218,
	"./game_icon/th/AB1505": 219,
	"./game_icon/th/AB1505.png": 219,
	"./game_icon/th/AB1506": 220,
	"./game_icon/th/AB1506.png": 220,
	"./game_icon/th/AB1507": 221,
	"./game_icon/th/AB1507.png": 221,
	"./game_icon/th/AB1510": 222,
	"./game_icon/th/AB1510.png": 222,
	"./game_icon/th/AB1512": 223,
	"./game_icon/th/AB1512.png": 223,
	"./game_icon/th/AB1515": 224,
	"./game_icon/th/AB1515.png": 224,
	"./game_icon/th/AB1516": 225,
	"./game_icon/th/AB1516.png": 225,
	"./game_icon/th/AB1517": 226,
	"./game_icon/th/AB1517.png": 226,
	"./game_icon/th/AB1520": 227,
	"./game_icon/th/AB1520.png": 227,
	"./game_icon/th/AB1521": 228,
	"./game_icon/th/AB1521.png": 228,
	"./game_icon/th/AB1522": 229,
	"./game_icon/th/AB1522.png": 229,
	"./game_icon/th/AB1523": 230,
	"./game_icon/th/AB1523.png": 230,
	"./game_icon/th/AB1524": 231,
	"./game_icon/th/AB1524.png": 231,
	"./game_icon/th/AB1525": 232,
	"./game_icon/th/AB1525.png": 232,
	"./game_icon/th/AB1526": 233,
	"./game_icon/th/AB1526.png": 233,
	"./game_icon/th/AB1527": 234,
	"./game_icon/th/AB1527.png": 234,
	"./game_icon/th/AB1528": 235,
	"./game_icon/th/AB1528.png": 235,
	"./game_icon/th/AB1529": 236,
	"./game_icon/th/AB1529.png": 236,
	"./game_icon/th/AB1530": 237,
	"./game_icon/th/AB1530.png": 237,
	"./game_icon/th/AB1531": 238,
	"./game_icon/th/AB1531.png": 238,
	"./game_icon/th/AB1532": 239,
	"./game_icon/th/AB1532.png": 239,
	"./game_icon/th/AB1534": 240,
	"./game_icon/th/AB1534.png": 240,
	"./game_icon/th/AB2001": 241,
	"./game_icon/th/AB2001.png": 241,
	"./game_icon/th/AB2002": 242,
	"./game_icon/th/AB2002.png": 242,
	"./game_icon/th/AB4001": 243,
	"./game_icon/th/AB4001.png": 243,
	"./game_icon/th/AB5001": 244,
	"./game_icon/th/AB5001.png": 244,
	"./game_icon/th/Thumbs.db": 640,
	"./game_icon/th/VG0002": 245,
	"./game_icon/th/VG0002.png": 245,
	"./game_icon/th/VG0003": 246,
	"./game_icon/th/VG0003.png": 246,
	"./game_icon/th/VG0004": 247,
	"./game_icon/th/VG0004.png": 247,
	"./game_icon/th/VG0007": 248,
	"./game_icon/th/VG0007.png": 248,
	"./game_icon/th/VG1001": 249,
	"./game_icon/th/VG1001.png": 249,
	"./game_icon/th/VG1002": 250,
	"./game_icon/th/VG1002.png": 250,
	"./game_icon/th/VG1003": 251,
	"./game_icon/th/VG1003.png": 251,
	"./game_icon/th/VG1004": 252,
	"./game_icon/th/VG1004.png": 252,
	"./game_icon/th/VG1005": 253,
	"./game_icon/th/VG1005.png": 253,
	"./game_icon/th/VG1007": 254,
	"./game_icon/th/VG1007.png": 254,
	"./game_icon/th/VGBACCARAT": 255,
	"./game_icon/th/VGBACCARAT.png": 255,
	"./game_icon/th/VGDRINSECT": 256,
	"./game_icon/th/VGDRINSECT.png": 256,
	"./game_icon/th/VGF01": 257,
	"./game_icon/th/VGF01.png": 257,
	"./game_icon/th/VGF02": 258,
	"./game_icon/th/VGF02.png": 258,
	"./game_icon/th/VGGyumaoC": 259,
	"./game_icon/th/VGGyumaoC.png": 259,
	"./game_icon/th/VGGyumaoM": 260,
	"./game_icon/th/VGGyumaoM.png": 260,
	"./game_icon/th/VGPHOENIX": 261,
	"./game_icon/th/VGPHOENIX.png": 261,
	"./game_icon/th/VGSEAFOOD2": 262,
	"./game_icon/th/VGSEAFOOD2.png": 262,
	"./game_icon/vi/AB1001": 263,
	"./game_icon/vi/AB1001.png": 263,
	"./game_icon/vi/AB1002": 264,
	"./game_icon/vi/AB1002.png": 264,
	"./game_icon/vi/AB1003": 265,
	"./game_icon/vi/AB1003.png": 265,
	"./game_icon/vi/AB1004": 266,
	"./game_icon/vi/AB1004.png": 266,
	"./game_icon/vi/AB1005": 267,
	"./game_icon/vi/AB1005.png": 267,
	"./game_icon/vi/AB1006": 268,
	"./game_icon/vi/AB1006.png": 268,
	"./game_icon/vi/AB1007": 269,
	"./game_icon/vi/AB1007.png": 269,
	"./game_icon/vi/AB1008": 270,
	"./game_icon/vi/AB1008.png": 270,
	"./game_icon/vi/AB1009": 271,
	"./game_icon/vi/AB1009.png": 271,
	"./game_icon/vi/AB1010": 272,
	"./game_icon/vi/AB1010.png": 272,
	"./game_icon/vi/AB1011": 273,
	"./game_icon/vi/AB1011.png": 273,
	"./game_icon/vi/AB1012": 274,
	"./game_icon/vi/AB1012.png": 274,
	"./game_icon/vi/AB1013": 275,
	"./game_icon/vi/AB1013.png": 275,
	"./game_icon/vi/AB1014": 276,
	"./game_icon/vi/AB1014.png": 276,
	"./game_icon/vi/AB1015": 277,
	"./game_icon/vi/AB1015.png": 277,
	"./game_icon/vi/AB1016": 278,
	"./game_icon/vi/AB1016.png": 278,
	"./game_icon/vi/AB1017": 279,
	"./game_icon/vi/AB1017.png": 279,
	"./game_icon/vi/AB1018": 280,
	"./game_icon/vi/AB1018.png": 280,
	"./game_icon/vi/AB1019": 281,
	"./game_icon/vi/AB1019.png": 281,
	"./game_icon/vi/AB1020": 282,
	"./game_icon/vi/AB1020.png": 282,
	"./game_icon/vi/AB1021": 283,
	"./game_icon/vi/AB1021.png": 283,
	"./game_icon/vi/AB1022": 284,
	"./game_icon/vi/AB1022.png": 284,
	"./game_icon/vi/AB1023": 285,
	"./game_icon/vi/AB1023.png": 285,
	"./game_icon/vi/AB1024": 286,
	"./game_icon/vi/AB1024.png": 286,
	"./game_icon/vi/AB1025": 287,
	"./game_icon/vi/AB1025.png": 287,
	"./game_icon/vi/AB1026": 288,
	"./game_icon/vi/AB1026.png": 288,
	"./game_icon/vi/AB1027": 289,
	"./game_icon/vi/AB1027.png": 289,
	"./game_icon/vi/AB1028": 290,
	"./game_icon/vi/AB1028.png": 290,
	"./game_icon/vi/AB1029": 291,
	"./game_icon/vi/AB1029.png": 291,
	"./game_icon/vi/AB1030": 292,
	"./game_icon/vi/AB1030.png": 292,
	"./game_icon/vi/AB1031": 293,
	"./game_icon/vi/AB1031.png": 293,
	"./game_icon/vi/AB1032": 294,
	"./game_icon/vi/AB1032.png": 294,
	"./game_icon/vi/AB1033": 295,
	"./game_icon/vi/AB1033.png": 295,
	"./game_icon/vi/AB1034": 296,
	"./game_icon/vi/AB1034.png": 296,
	"./game_icon/vi/AB1035": 297,
	"./game_icon/vi/AB1035.png": 297,
	"./game_icon/vi/AB1036": 298,
	"./game_icon/vi/AB1036.png": 298,
	"./game_icon/vi/AB1037": 299,
	"./game_icon/vi/AB1037.png": 299,
	"./game_icon/vi/AB1038": 300,
	"./game_icon/vi/AB1038.png": 300,
	"./game_icon/vi/AB1039": 301,
	"./game_icon/vi/AB1039.png": 301,
	"./game_icon/vi/AB1040": 302,
	"./game_icon/vi/AB1040.png": 302,
	"./game_icon/vi/AB1041": 303,
	"./game_icon/vi/AB1041.png": 303,
	"./game_icon/vi/AB1042": 304,
	"./game_icon/vi/AB1042.png": 304,
	"./game_icon/vi/AB1043": 305,
	"./game_icon/vi/AB1043.png": 305,
	"./game_icon/vi/AB1044": 306,
	"./game_icon/vi/AB1044.png": 306,
	"./game_icon/vi/AB1045": 307,
	"./game_icon/vi/AB1045.png": 307,
	"./game_icon/vi/AB1046": 308,
	"./game_icon/vi/AB1046.png": 308,
	"./game_icon/vi/AB1047": 309,
	"./game_icon/vi/AB1047.png": 309,
	"./game_icon/vi/AB1048": 310,
	"./game_icon/vi/AB1048.png": 310,
	"./game_icon/vi/AB1049": 311,
	"./game_icon/vi/AB1049.png": 311,
	"./game_icon/vi/AB1050": 312,
	"./game_icon/vi/AB1050.png": 312,
	"./game_icon/vi/AB1051": 313,
	"./game_icon/vi/AB1051.png": 313,
	"./game_icon/vi/AB1052": 314,
	"./game_icon/vi/AB1052.png": 314,
	"./game_icon/vi/AB1053": 315,
	"./game_icon/vi/AB1053.png": 315,
	"./game_icon/vi/AB1054": 316,
	"./game_icon/vi/AB1054.png": 316,
	"./game_icon/vi/AB1055": 317,
	"./game_icon/vi/AB1055.png": 317,
	"./game_icon/vi/AB1501": 318,
	"./game_icon/vi/AB1501.png": 318,
	"./game_icon/vi/AB1502": 319,
	"./game_icon/vi/AB1502.png": 319,
	"./game_icon/vi/AB1503": 320,
	"./game_icon/vi/AB1503.png": 320,
	"./game_icon/vi/AB1504": 321,
	"./game_icon/vi/AB1504.png": 321,
	"./game_icon/vi/AB1505": 322,
	"./game_icon/vi/AB1505.png": 322,
	"./game_icon/vi/AB1506": 323,
	"./game_icon/vi/AB1506.png": 323,
	"./game_icon/vi/AB1507": 324,
	"./game_icon/vi/AB1507.png": 324,
	"./game_icon/vi/AB1510": 325,
	"./game_icon/vi/AB1510.png": 325,
	"./game_icon/vi/AB1512": 326,
	"./game_icon/vi/AB1512.png": 326,
	"./game_icon/vi/AB1515": 327,
	"./game_icon/vi/AB1515.png": 327,
	"./game_icon/vi/AB1516": 328,
	"./game_icon/vi/AB1516.png": 328,
	"./game_icon/vi/AB1517": 329,
	"./game_icon/vi/AB1517.png": 329,
	"./game_icon/vi/AB1520": 330,
	"./game_icon/vi/AB1520.png": 330,
	"./game_icon/vi/AB1521": 331,
	"./game_icon/vi/AB1521.png": 331,
	"./game_icon/vi/AB1522": 332,
	"./game_icon/vi/AB1522.png": 332,
	"./game_icon/vi/AB1523": 333,
	"./game_icon/vi/AB1523.png": 333,
	"./game_icon/vi/AB1524": 334,
	"./game_icon/vi/AB1524.png": 334,
	"./game_icon/vi/AB1525": 335,
	"./game_icon/vi/AB1525.png": 335,
	"./game_icon/vi/AB1526": 336,
	"./game_icon/vi/AB1526.png": 336,
	"./game_icon/vi/AB1527": 337,
	"./game_icon/vi/AB1527.png": 337,
	"./game_icon/vi/AB1528": 338,
	"./game_icon/vi/AB1528.png": 338,
	"./game_icon/vi/AB1529": 339,
	"./game_icon/vi/AB1529.png": 339,
	"./game_icon/vi/AB1530": 340,
	"./game_icon/vi/AB1530.png": 340,
	"./game_icon/vi/AB1531": 341,
	"./game_icon/vi/AB1531.png": 341,
	"./game_icon/vi/AB1532": 342,
	"./game_icon/vi/AB1532.png": 342,
	"./game_icon/vi/AB1534": 343,
	"./game_icon/vi/AB1534.png": 343,
	"./game_icon/vi/AB2001": 344,
	"./game_icon/vi/AB2001.png": 344,
	"./game_icon/vi/AB2002": 345,
	"./game_icon/vi/AB2002.png": 345,
	"./game_icon/vi/AB3001": 346,
	"./game_icon/vi/AB3001.png": 346,
	"./game_icon/vi/AB4001": 347,
	"./game_icon/vi/AB4001.png": 347,
	"./game_icon/vi/AB4003": 348,
	"./game_icon/vi/AB4003.png": 348,
	"./game_icon/vi/AB5001": 349,
	"./game_icon/vi/AB5001.png": 349,
	"./game_icon/vi/BC1039": 350,
	"./game_icon/vi/BC1039.png": 350,
	"./game_icon/vi/BC3041": 351,
	"./game_icon/vi/BC3041.png": 351,
	"./game_icon/vi/BC3049": 352,
	"./game_icon/vi/BC3049.png": 352,
	"./game_icon/vi/BC4056": 353,
	"./game_icon/vi/BC4056.png": 353,
	"./game_icon/vi/BC4057": 354,
	"./game_icon/vi/BC4057.png": 354,
	"./game_icon/vi/BC4058": 355,
	"./game_icon/vi/BC4058.png": 355,
	"./game_icon/vi/BC4062": 356,
	"./game_icon/vi/BC4062.png": 356,
	"./game_icon/vi/BC4071": 357,
	"./game_icon/vi/BC4071.png": 357,
	"./game_icon/vi/FT038": 358,
	"./game_icon/vi/FT038.png": 358,
	"./game_icon/vi/Thumbs.db": 641,
	"./game_icon/vi/VG0001": 359,
	"./game_icon/vi/VG0001.png": 359,
	"./game_icon/vi/VG0002": 360,
	"./game_icon/vi/VG0002.png": 360,
	"./game_icon/vi/VG0003": 361,
	"./game_icon/vi/VG0003.png": 361,
	"./game_icon/vi/VG0004": 362,
	"./game_icon/vi/VG0004.png": 362,
	"./game_icon/vi/VG0007": 363,
	"./game_icon/vi/VG0007.png": 363,
	"./game_icon/vi/VG1001": 364,
	"./game_icon/vi/VG1001.png": 364,
	"./game_icon/vi/VG1002": 365,
	"./game_icon/vi/VG1002.png": 365,
	"./game_icon/vi/VG1003": 366,
	"./game_icon/vi/VG1003.png": 366,
	"./game_icon/vi/VG1004": 367,
	"./game_icon/vi/VG1004.png": 367,
	"./game_icon/vi/VG1005": 368,
	"./game_icon/vi/VG1005.png": 368,
	"./game_icon/vi/VG1007": 369,
	"./game_icon/vi/VG1007.png": 369,
	"./game_icon/vi/VGBACCARAT": 370,
	"./game_icon/vi/VGBACCARAT.png": 370,
	"./game_icon/vi/VGDRINSECT": 371,
	"./game_icon/vi/VGDRINSECT.png": 371,
	"./game_icon/vi/VGF01": 372,
	"./game_icon/vi/VGF01.png": 372,
	"./game_icon/vi/VGF02": 373,
	"./game_icon/vi/VGF02.png": 373,
	"./game_icon/vi/VGGyumaoC": 374,
	"./game_icon/vi/VGGyumaoC.png": 374,
	"./game_icon/vi/VGGyumaoM": 375,
	"./game_icon/vi/VGGyumaoM.png": 375,
	"./game_icon/vi/VGPHOENIX": 376,
	"./game_icon/vi/VGPHOENIX.png": 376,
	"./game_icon/vi/VGSEAFOOD2": 377,
	"./game_icon/vi/VGSEAFOOD2.png": 377,
	"./game_icon/zh-cn/AB1001": 378,
	"./game_icon/zh-cn/AB1001.png": 378,
	"./game_icon/zh-cn/AB1002": 379,
	"./game_icon/zh-cn/AB1002.png": 379,
	"./game_icon/zh-cn/AB1003": 380,
	"./game_icon/zh-cn/AB1003.png": 380,
	"./game_icon/zh-cn/AB1004": 381,
	"./game_icon/zh-cn/AB1004.png": 381,
	"./game_icon/zh-cn/AB1005": 382,
	"./game_icon/zh-cn/AB1005.png": 382,
	"./game_icon/zh-cn/AB1006": 383,
	"./game_icon/zh-cn/AB1006.png": 383,
	"./game_icon/zh-cn/AB1007": 384,
	"./game_icon/zh-cn/AB1007.png": 384,
	"./game_icon/zh-cn/AB1008": 385,
	"./game_icon/zh-cn/AB1008.png": 385,
	"./game_icon/zh-cn/AB1009": 386,
	"./game_icon/zh-cn/AB1009.png": 386,
	"./game_icon/zh-cn/AB1010": 387,
	"./game_icon/zh-cn/AB1010.png": 387,
	"./game_icon/zh-cn/AB1011": 388,
	"./game_icon/zh-cn/AB1011.png": 388,
	"./game_icon/zh-cn/AB1012": 389,
	"./game_icon/zh-cn/AB1012.png": 389,
	"./game_icon/zh-cn/AB1013": 390,
	"./game_icon/zh-cn/AB1013.png": 390,
	"./game_icon/zh-cn/AB1014": 391,
	"./game_icon/zh-cn/AB1014.png": 391,
	"./game_icon/zh-cn/AB1015": 392,
	"./game_icon/zh-cn/AB1015.png": 392,
	"./game_icon/zh-cn/AB1016": 393,
	"./game_icon/zh-cn/AB1016.png": 393,
	"./game_icon/zh-cn/AB1017": 394,
	"./game_icon/zh-cn/AB1017.png": 394,
	"./game_icon/zh-cn/AB1018": 395,
	"./game_icon/zh-cn/AB1018.png": 395,
	"./game_icon/zh-cn/AB1019": 396,
	"./game_icon/zh-cn/AB1019.png": 396,
	"./game_icon/zh-cn/AB1020": 397,
	"./game_icon/zh-cn/AB1020.png": 397,
	"./game_icon/zh-cn/AB1021": 398,
	"./game_icon/zh-cn/AB1021.png": 398,
	"./game_icon/zh-cn/AB1022": 399,
	"./game_icon/zh-cn/AB1022.png": 399,
	"./game_icon/zh-cn/AB1023": 400,
	"./game_icon/zh-cn/AB1023.png": 400,
	"./game_icon/zh-cn/AB1024": 401,
	"./game_icon/zh-cn/AB1024.png": 401,
	"./game_icon/zh-cn/AB1025": 402,
	"./game_icon/zh-cn/AB1025.png": 402,
	"./game_icon/zh-cn/AB1026": 403,
	"./game_icon/zh-cn/AB1026.png": 403,
	"./game_icon/zh-cn/AB1027": 404,
	"./game_icon/zh-cn/AB1027.png": 404,
	"./game_icon/zh-cn/AB1028": 405,
	"./game_icon/zh-cn/AB1028.png": 405,
	"./game_icon/zh-cn/AB1029": 406,
	"./game_icon/zh-cn/AB1029.png": 406,
	"./game_icon/zh-cn/AB1030": 407,
	"./game_icon/zh-cn/AB1030.png": 407,
	"./game_icon/zh-cn/AB1031": 408,
	"./game_icon/zh-cn/AB1031.png": 408,
	"./game_icon/zh-cn/AB1032": 409,
	"./game_icon/zh-cn/AB1032.png": 409,
	"./game_icon/zh-cn/AB1033": 410,
	"./game_icon/zh-cn/AB1033.png": 410,
	"./game_icon/zh-cn/AB1034": 411,
	"./game_icon/zh-cn/AB1034.png": 411,
	"./game_icon/zh-cn/AB1035": 412,
	"./game_icon/zh-cn/AB1035.png": 412,
	"./game_icon/zh-cn/AB1036": 413,
	"./game_icon/zh-cn/AB1036.png": 413,
	"./game_icon/zh-cn/AB1037": 414,
	"./game_icon/zh-cn/AB1037.png": 414,
	"./game_icon/zh-cn/AB1038": 415,
	"./game_icon/zh-cn/AB1038.png": 415,
	"./game_icon/zh-cn/AB1039": 416,
	"./game_icon/zh-cn/AB1039.png": 416,
	"./game_icon/zh-cn/AB1040": 417,
	"./game_icon/zh-cn/AB1040.png": 417,
	"./game_icon/zh-cn/AB1040_": 418,
	"./game_icon/zh-cn/AB1040_.png": 418,
	"./game_icon/zh-cn/AB1041": 419,
	"./game_icon/zh-cn/AB1041.png": 419,
	"./game_icon/zh-cn/AB1042": 420,
	"./game_icon/zh-cn/AB1042.png": 420,
	"./game_icon/zh-cn/AB1043": 421,
	"./game_icon/zh-cn/AB1043.png": 421,
	"./game_icon/zh-cn/AB1044": 422,
	"./game_icon/zh-cn/AB1044.png": 422,
	"./game_icon/zh-cn/AB1045": 423,
	"./game_icon/zh-cn/AB1045.png": 423,
	"./game_icon/zh-cn/AB1046": 424,
	"./game_icon/zh-cn/AB1046.png": 424,
	"./game_icon/zh-cn/AB1047": 425,
	"./game_icon/zh-cn/AB1047.png": 425,
	"./game_icon/zh-cn/AB1048": 426,
	"./game_icon/zh-cn/AB1048.png": 426,
	"./game_icon/zh-cn/AB1049": 427,
	"./game_icon/zh-cn/AB1049.png": 427,
	"./game_icon/zh-cn/AB1050": 428,
	"./game_icon/zh-cn/AB1050.png": 428,
	"./game_icon/zh-cn/AB1051": 429,
	"./game_icon/zh-cn/AB1051.png": 429,
	"./game_icon/zh-cn/AB1052": 430,
	"./game_icon/zh-cn/AB1052.png": 430,
	"./game_icon/zh-cn/AB1053": 431,
	"./game_icon/zh-cn/AB1053.png": 431,
	"./game_icon/zh-cn/AB1054": 432,
	"./game_icon/zh-cn/AB1054.png": 432,
	"./game_icon/zh-cn/AB1055": 433,
	"./game_icon/zh-cn/AB1055.png": 433,
	"./game_icon/zh-cn/AB1501": 434,
	"./game_icon/zh-cn/AB1501.png": 434,
	"./game_icon/zh-cn/AB1502": 435,
	"./game_icon/zh-cn/AB1502.png": 435,
	"./game_icon/zh-cn/AB1503": 436,
	"./game_icon/zh-cn/AB1503.png": 436,
	"./game_icon/zh-cn/AB1503_": 437,
	"./game_icon/zh-cn/AB1503_.png": 437,
	"./game_icon/zh-cn/AB1504": 438,
	"./game_icon/zh-cn/AB1504.png": 438,
	"./game_icon/zh-cn/AB1505": 439,
	"./game_icon/zh-cn/AB1505.png": 439,
	"./game_icon/zh-cn/AB1506": 440,
	"./game_icon/zh-cn/AB1506.png": 440,
	"./game_icon/zh-cn/AB1507": 441,
	"./game_icon/zh-cn/AB1507.png": 441,
	"./game_icon/zh-cn/AB1508_": 442,
	"./game_icon/zh-cn/AB1508_.png": 442,
	"./game_icon/zh-cn/AB1509": 443,
	"./game_icon/zh-cn/AB1509.png": 443,
	"./game_icon/zh-cn/AB1510": 444,
	"./game_icon/zh-cn/AB1510.png": 444,
	"./game_icon/zh-cn/AB1511": 445,
	"./game_icon/zh-cn/AB1511.png": 445,
	"./game_icon/zh-cn/AB1512": 446,
	"./game_icon/zh-cn/AB1512.png": 446,
	"./game_icon/zh-cn/AB1515": 447,
	"./game_icon/zh-cn/AB1515.png": 447,
	"./game_icon/zh-cn/AB1516": 448,
	"./game_icon/zh-cn/AB1516.png": 448,
	"./game_icon/zh-cn/AB1517": 449,
	"./game_icon/zh-cn/AB1517.png": 449,
	"./game_icon/zh-cn/AB1520": 450,
	"./game_icon/zh-cn/AB1520.png": 450,
	"./game_icon/zh-cn/AB1521": 451,
	"./game_icon/zh-cn/AB1521.png": 451,
	"./game_icon/zh-cn/AB1522": 452,
	"./game_icon/zh-cn/AB1522.png": 452,
	"./game_icon/zh-cn/AB1523": 453,
	"./game_icon/zh-cn/AB1523.png": 453,
	"./game_icon/zh-cn/AB1524": 454,
	"./game_icon/zh-cn/AB1524.png": 454,
	"./game_icon/zh-cn/AB1525": 455,
	"./game_icon/zh-cn/AB1525.png": 455,
	"./game_icon/zh-cn/AB1526": 456,
	"./game_icon/zh-cn/AB1526.png": 456,
	"./game_icon/zh-cn/AB1527": 457,
	"./game_icon/zh-cn/AB1527.png": 457,
	"./game_icon/zh-cn/AB1528": 458,
	"./game_icon/zh-cn/AB1528.png": 458,
	"./game_icon/zh-cn/AB1529": 459,
	"./game_icon/zh-cn/AB1529.png": 459,
	"./game_icon/zh-cn/AB1530": 460,
	"./game_icon/zh-cn/AB1530.png": 460,
	"./game_icon/zh-cn/AB1531": 461,
	"./game_icon/zh-cn/AB1531.png": 461,
	"./game_icon/zh-cn/AB1532": 462,
	"./game_icon/zh-cn/AB1532.png": 462,
	"./game_icon/zh-cn/AB1534": 463,
	"./game_icon/zh-cn/AB1534.png": 463,
	"./game_icon/zh-cn/AB2001": 464,
	"./game_icon/zh-cn/AB2001.png": 464,
	"./game_icon/zh-cn/AB2002": 465,
	"./game_icon/zh-cn/AB2002.png": 465,
	"./game_icon/zh-cn/AB3001": 466,
	"./game_icon/zh-cn/AB3001.png": 466,
	"./game_icon/zh-cn/AB4001": 467,
	"./game_icon/zh-cn/AB4001.png": 467,
	"./game_icon/zh-cn/AB4003": 468,
	"./game_icon/zh-cn/AB4003.png": 468,
	"./game_icon/zh-cn/AB5001": 469,
	"./game_icon/zh-cn/AB5001.png": 469,
	"./game_icon/zh-cn/BC1039": 470,
	"./game_icon/zh-cn/BC1039.png": 470,
	"./game_icon/zh-cn/BC3041": 471,
	"./game_icon/zh-cn/BC3041.png": 471,
	"./game_icon/zh-cn/BC3049": 472,
	"./game_icon/zh-cn/BC3049.png": 472,
	"./game_icon/zh-cn/BC4056": 473,
	"./game_icon/zh-cn/BC4056.png": 473,
	"./game_icon/zh-cn/BC4057": 474,
	"./game_icon/zh-cn/BC4057.png": 474,
	"./game_icon/zh-cn/BC4058": 475,
	"./game_icon/zh-cn/BC4058.png": 475,
	"./game_icon/zh-cn/BC4062": 476,
	"./game_icon/zh-cn/BC4062.png": 476,
	"./game_icon/zh-cn/BC4071": 477,
	"./game_icon/zh-cn/BC4071.png": 477,
	"./game_icon/zh-cn/FT038": 478,
	"./game_icon/zh-cn/FT038.png": 478,
	"./game_icon/zh-cn/Thumbs.db": 642,
	"./game_icon/zh-cn/VG0001": 479,
	"./game_icon/zh-cn/VG0001.png": 479,
	"./game_icon/zh-cn/VG0002": 480,
	"./game_icon/zh-cn/VG0002.png": 480,
	"./game_icon/zh-cn/VG0003": 481,
	"./game_icon/zh-cn/VG0003.png": 481,
	"./game_icon/zh-cn/VG0004": 482,
	"./game_icon/zh-cn/VG0004.png": 482,
	"./game_icon/zh-cn/VG0007": 483,
	"./game_icon/zh-cn/VG0007.png": 483,
	"./game_icon/zh-cn/VG1001": 484,
	"./game_icon/zh-cn/VG1001.png": 484,
	"./game_icon/zh-cn/VG1002": 485,
	"./game_icon/zh-cn/VG1002.png": 485,
	"./game_icon/zh-cn/VG1003": 486,
	"./game_icon/zh-cn/VG1003.png": 486,
	"./game_icon/zh-cn/VG1004": 487,
	"./game_icon/zh-cn/VG1004.png": 487,
	"./game_icon/zh-cn/VG1005": 488,
	"./game_icon/zh-cn/VG1005.png": 488,
	"./game_icon/zh-cn/VG1007": 489,
	"./game_icon/zh-cn/VG1007.png": 489,
	"./game_icon/zh-cn/VGBACCARAT": 490,
	"./game_icon/zh-cn/VGBACCARAT.png": 490,
	"./game_icon/zh-cn/VGDRINSECT": 491,
	"./game_icon/zh-cn/VGDRINSECT.png": 491,
	"./game_icon/zh-cn/VGF01": 492,
	"./game_icon/zh-cn/VGF01.png": 492,
	"./game_icon/zh-cn/VGF02": 493,
	"./game_icon/zh-cn/VGF02.png": 493,
	"./game_icon/zh-cn/VGGyumaoC": 494,
	"./game_icon/zh-cn/VGGyumaoC.png": 494,
	"./game_icon/zh-cn/VGGyumaoM": 495,
	"./game_icon/zh-cn/VGGyumaoM.png": 495,
	"./game_icon/zh-cn/VGPHOENIX": 496,
	"./game_icon/zh-cn/VGPHOENIX.png": 496,
	"./game_icon/zh-cn/VGROULETTE": 497,
	"./game_icon/zh-cn/VGROULETTE.png": 497,
	"./game_icon/zh-cn/VGSEAFOOD2": 498,
	"./game_icon/zh-cn/VGSEAFOOD2.png": 498,
	"./game_icon/zh-tw/AB1001": 499,
	"./game_icon/zh-tw/AB1001.png": 499,
	"./game_icon/zh-tw/AB1002": 500,
	"./game_icon/zh-tw/AB1002.png": 500,
	"./game_icon/zh-tw/AB1003": 501,
	"./game_icon/zh-tw/AB1003.png": 501,
	"./game_icon/zh-tw/AB1004": 502,
	"./game_icon/zh-tw/AB1004.png": 502,
	"./game_icon/zh-tw/AB1005": 503,
	"./game_icon/zh-tw/AB1005.png": 503,
	"./game_icon/zh-tw/AB1006": 504,
	"./game_icon/zh-tw/AB1006.png": 504,
	"./game_icon/zh-tw/AB1007": 505,
	"./game_icon/zh-tw/AB1007.png": 505,
	"./game_icon/zh-tw/AB1008": 506,
	"./game_icon/zh-tw/AB1008.png": 506,
	"./game_icon/zh-tw/AB1009": 507,
	"./game_icon/zh-tw/AB1009.png": 507,
	"./game_icon/zh-tw/AB1010": 508,
	"./game_icon/zh-tw/AB1010.png": 508,
	"./game_icon/zh-tw/AB1011": 509,
	"./game_icon/zh-tw/AB1011.png": 509,
	"./game_icon/zh-tw/AB1012": 510,
	"./game_icon/zh-tw/AB1012.png": 510,
	"./game_icon/zh-tw/AB1013": 511,
	"./game_icon/zh-tw/AB1013.png": 511,
	"./game_icon/zh-tw/AB1014": 512,
	"./game_icon/zh-tw/AB1014.png": 512,
	"./game_icon/zh-tw/AB1015": 513,
	"./game_icon/zh-tw/AB1015.png": 513,
	"./game_icon/zh-tw/AB1016": 514,
	"./game_icon/zh-tw/AB1016.png": 514,
	"./game_icon/zh-tw/AB1017": 515,
	"./game_icon/zh-tw/AB1017.png": 515,
	"./game_icon/zh-tw/AB1018": 516,
	"./game_icon/zh-tw/AB1018.png": 516,
	"./game_icon/zh-tw/AB1019": 517,
	"./game_icon/zh-tw/AB1019.png": 517,
	"./game_icon/zh-tw/AB1020": 518,
	"./game_icon/zh-tw/AB1020.png": 518,
	"./game_icon/zh-tw/AB1021": 519,
	"./game_icon/zh-tw/AB1021.png": 519,
	"./game_icon/zh-tw/AB1022": 520,
	"./game_icon/zh-tw/AB1022.png": 520,
	"./game_icon/zh-tw/AB1023": 521,
	"./game_icon/zh-tw/AB1023.png": 521,
	"./game_icon/zh-tw/AB1024": 522,
	"./game_icon/zh-tw/AB1024.png": 522,
	"./game_icon/zh-tw/AB1025": 523,
	"./game_icon/zh-tw/AB1025.png": 523,
	"./game_icon/zh-tw/AB1026": 524,
	"./game_icon/zh-tw/AB1026.png": 524,
	"./game_icon/zh-tw/AB1027": 525,
	"./game_icon/zh-tw/AB1027.png": 525,
	"./game_icon/zh-tw/AB1028": 526,
	"./game_icon/zh-tw/AB1028.png": 526,
	"./game_icon/zh-tw/AB1029": 527,
	"./game_icon/zh-tw/AB1029.png": 527,
	"./game_icon/zh-tw/AB1030": 528,
	"./game_icon/zh-tw/AB1030.png": 528,
	"./game_icon/zh-tw/AB1031": 529,
	"./game_icon/zh-tw/AB1031.png": 529,
	"./game_icon/zh-tw/AB1032": 530,
	"./game_icon/zh-tw/AB1032.png": 530,
	"./game_icon/zh-tw/AB1033": 531,
	"./game_icon/zh-tw/AB1033.png": 531,
	"./game_icon/zh-tw/AB1034": 532,
	"./game_icon/zh-tw/AB1034.png": 532,
	"./game_icon/zh-tw/AB1035": 533,
	"./game_icon/zh-tw/AB1035.png": 533,
	"./game_icon/zh-tw/AB1036": 534,
	"./game_icon/zh-tw/AB1036.png": 534,
	"./game_icon/zh-tw/AB1037": 535,
	"./game_icon/zh-tw/AB1037.png": 535,
	"./game_icon/zh-tw/AB1038": 536,
	"./game_icon/zh-tw/AB1038.png": 536,
	"./game_icon/zh-tw/AB1039": 537,
	"./game_icon/zh-tw/AB1039.png": 537,
	"./game_icon/zh-tw/AB1040": 538,
	"./game_icon/zh-tw/AB1040.png": 538,
	"./game_icon/zh-tw/AB1041": 539,
	"./game_icon/zh-tw/AB1041.png": 539,
	"./game_icon/zh-tw/AB1042": 540,
	"./game_icon/zh-tw/AB1042.png": 540,
	"./game_icon/zh-tw/AB1043": 541,
	"./game_icon/zh-tw/AB1043.png": 541,
	"./game_icon/zh-tw/AB1044": 542,
	"./game_icon/zh-tw/AB1044.png": 542,
	"./game_icon/zh-tw/AB1045": 543,
	"./game_icon/zh-tw/AB1045.png": 543,
	"./game_icon/zh-tw/AB1046": 544,
	"./game_icon/zh-tw/AB1046.png": 544,
	"./game_icon/zh-tw/AB1047": 545,
	"./game_icon/zh-tw/AB1047.png": 545,
	"./game_icon/zh-tw/AB1048": 546,
	"./game_icon/zh-tw/AB1048.png": 546,
	"./game_icon/zh-tw/AB1049": 547,
	"./game_icon/zh-tw/AB1049.png": 547,
	"./game_icon/zh-tw/AB1050": 548,
	"./game_icon/zh-tw/AB1050.png": 548,
	"./game_icon/zh-tw/AB1051": 549,
	"./game_icon/zh-tw/AB1051.png": 549,
	"./game_icon/zh-tw/AB1052": 550,
	"./game_icon/zh-tw/AB1052.png": 550,
	"./game_icon/zh-tw/AB1053": 551,
	"./game_icon/zh-tw/AB1053.png": 551,
	"./game_icon/zh-tw/AB1054": 552,
	"./game_icon/zh-tw/AB1054.png": 552,
	"./game_icon/zh-tw/AB1055": 553,
	"./game_icon/zh-tw/AB1055.png": 553,
	"./game_icon/zh-tw/AB1501": 554,
	"./game_icon/zh-tw/AB1501.png": 554,
	"./game_icon/zh-tw/AB1502": 555,
	"./game_icon/zh-tw/AB1502.png": 555,
	"./game_icon/zh-tw/AB1503": 556,
	"./game_icon/zh-tw/AB1503.png": 556,
	"./game_icon/zh-tw/AB1504": 557,
	"./game_icon/zh-tw/AB1504.png": 557,
	"./game_icon/zh-tw/AB1505": 558,
	"./game_icon/zh-tw/AB1505.png": 558,
	"./game_icon/zh-tw/AB1506": 559,
	"./game_icon/zh-tw/AB1506.png": 559,
	"./game_icon/zh-tw/AB1507": 560,
	"./game_icon/zh-tw/AB1507.png": 560,
	"./game_icon/zh-tw/AB1508": 561,
	"./game_icon/zh-tw/AB1508.png": 561,
	"./game_icon/zh-tw/AB1509": 562,
	"./game_icon/zh-tw/AB1509.png": 562,
	"./game_icon/zh-tw/AB1510": 563,
	"./game_icon/zh-tw/AB1510.png": 563,
	"./game_icon/zh-tw/AB1511": 564,
	"./game_icon/zh-tw/AB1511.png": 564,
	"./game_icon/zh-tw/AB1512": 565,
	"./game_icon/zh-tw/AB1512.png": 565,
	"./game_icon/zh-tw/AB1515": 566,
	"./game_icon/zh-tw/AB1515.png": 566,
	"./game_icon/zh-tw/AB1516": 567,
	"./game_icon/zh-tw/AB1516.png": 567,
	"./game_icon/zh-tw/AB1517": 568,
	"./game_icon/zh-tw/AB1517.png": 568,
	"./game_icon/zh-tw/AB1520": 569,
	"./game_icon/zh-tw/AB1520.png": 569,
	"./game_icon/zh-tw/AB1521": 570,
	"./game_icon/zh-tw/AB1521.png": 570,
	"./game_icon/zh-tw/AB1522": 571,
	"./game_icon/zh-tw/AB1522.png": 571,
	"./game_icon/zh-tw/AB1523": 572,
	"./game_icon/zh-tw/AB1523.png": 572,
	"./game_icon/zh-tw/AB1524": 573,
	"./game_icon/zh-tw/AB1524.png": 573,
	"./game_icon/zh-tw/AB1525": 574,
	"./game_icon/zh-tw/AB1525.png": 574,
	"./game_icon/zh-tw/AB1526": 575,
	"./game_icon/zh-tw/AB1526.png": 575,
	"./game_icon/zh-tw/AB1527": 576,
	"./game_icon/zh-tw/AB1527.png": 576,
	"./game_icon/zh-tw/AB1528": 577,
	"./game_icon/zh-tw/AB1528.png": 577,
	"./game_icon/zh-tw/AB1529": 578,
	"./game_icon/zh-tw/AB1529.png": 578,
	"./game_icon/zh-tw/AB1530": 579,
	"./game_icon/zh-tw/AB1530.png": 579,
	"./game_icon/zh-tw/AB1531": 580,
	"./game_icon/zh-tw/AB1531.png": 580,
	"./game_icon/zh-tw/AB1532": 581,
	"./game_icon/zh-tw/AB1532.png": 581,
	"./game_icon/zh-tw/AB1534": 582,
	"./game_icon/zh-tw/AB1534.png": 582,
	"./game_icon/zh-tw/AB2001": 583,
	"./game_icon/zh-tw/AB2001.png": 583,
	"./game_icon/zh-tw/AB2002": 584,
	"./game_icon/zh-tw/AB2002.png": 584,
	"./game_icon/zh-tw/AB3001": 585,
	"./game_icon/zh-tw/AB3001.png": 585,
	"./game_icon/zh-tw/AB4001": 586,
	"./game_icon/zh-tw/AB4001.png": 586,
	"./game_icon/zh-tw/AB4003": 587,
	"./game_icon/zh-tw/AB4003.png": 587,
	"./game_icon/zh-tw/AB5001": 588,
	"./game_icon/zh-tw/AB5001.png": 588,
	"./game_icon/zh-tw/BC1039": 589,
	"./game_icon/zh-tw/BC1039.png": 589,
	"./game_icon/zh-tw/BC3041": 590,
	"./game_icon/zh-tw/BC3041.png": 590,
	"./game_icon/zh-tw/BC3049": 591,
	"./game_icon/zh-tw/BC3049.png": 591,
	"./game_icon/zh-tw/BC4056": 592,
	"./game_icon/zh-tw/BC4056.png": 592,
	"./game_icon/zh-tw/BC4057": 593,
	"./game_icon/zh-tw/BC4057.png": 593,
	"./game_icon/zh-tw/BC4058": 594,
	"./game_icon/zh-tw/BC4058.png": 594,
	"./game_icon/zh-tw/BC4062": 595,
	"./game_icon/zh-tw/BC4062.png": 595,
	"./game_icon/zh-tw/BC4071": 596,
	"./game_icon/zh-tw/BC4071.png": 596,
	"./game_icon/zh-tw/FT038": 597,
	"./game_icon/zh-tw/FT038.png": 597,
	"./game_icon/zh-tw/Thumbs.db": 643,
	"./game_icon/zh-tw/VG0001": 598,
	"./game_icon/zh-tw/VG0001.png": 598,
	"./game_icon/zh-tw/VG0002": 599,
	"./game_icon/zh-tw/VG0002.png": 599,
	"./game_icon/zh-tw/VG0003": 600,
	"./game_icon/zh-tw/VG0003.png": 600,
	"./game_icon/zh-tw/VG0004": 601,
	"./game_icon/zh-tw/VG0004.png": 601,
	"./game_icon/zh-tw/VG0007": 602,
	"./game_icon/zh-tw/VG0007.png": 602,
	"./game_icon/zh-tw/VG1001": 603,
	"./game_icon/zh-tw/VG1001.png": 603,
	"./game_icon/zh-tw/VG1002": 604,
	"./game_icon/zh-tw/VG1002.png": 604,
	"./game_icon/zh-tw/VG1003": 605,
	"./game_icon/zh-tw/VG1003.png": 605,
	"./game_icon/zh-tw/VG1004": 606,
	"./game_icon/zh-tw/VG1004.png": 606,
	"./game_icon/zh-tw/VG1005": 607,
	"./game_icon/zh-tw/VG1005.png": 607,
	"./game_icon/zh-tw/VG1007": 608,
	"./game_icon/zh-tw/VG1007.png": 608,
	"./game_icon/zh-tw/VGBACCARAT": 609,
	"./game_icon/zh-tw/VGBACCARAT.png": 609,
	"./game_icon/zh-tw/VGDRINSECT": 610,
	"./game_icon/zh-tw/VGDRINSECT.png": 610,
	"./game_icon/zh-tw/VGF01": 611,
	"./game_icon/zh-tw/VGF01.png": 611,
	"./game_icon/zh-tw/VGF02": 612,
	"./game_icon/zh-tw/VGF02.png": 612,
	"./game_icon/zh-tw/VGGyumaoC": 613,
	"./game_icon/zh-tw/VGGyumaoC.png": 613,
	"./game_icon/zh-tw/VGGyumaoM": 614,
	"./game_icon/zh-tw/VGGyumaoM.png": 614,
	"./game_icon/zh-tw/VGPHOENIX": 615,
	"./game_icon/zh-tw/VGPHOENIX.png": 615,
	"./game_icon/zh-tw/VGROULETTE": 616,
	"./game_icon/zh-tw/VGROULETTE.png": 616,
	"./game_icon/zh-tw/VGSEAFOOD2": 617,
	"./game_icon/zh-tw/VGSEAFOOD2.png": 617,
	"./gli-cf": 618,
	"./gli-cf.png": 618,
	"./gli-logo": 619,
	"./gli-logo.png": 619,
	"./indexCenterBanner": 620,
	"./indexCenterBanner.png": 620,
	"./logo": 621,
	"./logo.png": 621,
	"./logo_w": 622,
	"./logo_w.png": 622,
	"./npc": 623,
	"./npc.png": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;